import React from 'react';
import { HexColorPicker } from 'react-colorful';
import { ToolSubmenu } from './ToolSubmenu';
import { sceneBackgroundSwatch } from '../../Utils/sceneBackground';

export const BG_SWATCHES = [
  null,
  '#ffffff',
  '#f5f5f4',
  '#d4d4d8',
  '#a1a1aa',
  '#71717a',
  '#3f3f46',
  '#27272a',
  '#18181b',
  '#000000',
  '#eab308',
  '#ca8a04',
  '#ef4444',
  '#f97316',
  '#22c55e',
  '#14b8a6',
  '#3b82f6',
  '#6366f1',
  '#a855f7',
  '#ec4899',
  '#87ceeb',
  '#1e3a5f',
  '#14532d',
];

export default function SceneBackgroundStrip({
  open,
  layout = 'row',
  sceneBgColor,
  onSceneBgChange,
  onClose,
}) {
  if (!open) return null;

  const isColumn = layout === 'column';

  return (
    <ToolSubmenu layout={layout} label="Background" onClose={onClose}>
      <div
        className={
          isColumn
            ? 'flex flex-col gap-2 w-full'
            : 'flex items-center gap-2 min-w-0 flex-wrap'
        }
      >
        <div
          className={
            isColumn
              ? 'grid grid-cols-6 gap-1'
              : 'flex items-center gap-1 flex-wrap shrink-0'
          }
        >
          {BG_SWATCHES.map((c, i) => (
            <button
              key={i}
              type="button"
              title={c || 'Default radial'}
              onClick={() => onSceneBgChange?.(c)}
              className="m-0 h-5 w-5 rounded-sm border border-yellow-600/30 p-0 shrink-0"
              style={{
                background: sceneBackgroundSwatch(c),
                outline:
                  (c === null && !sceneBgColor) || c === sceneBgColor ? '1px solid #eab308' : undefined,
              }}
            />
          ))}
        </div>

        <div className={isColumn ? 'w-full' : 'shrink-0 w-[7.5rem]'}>
          <HexColorPicker
            color={sceneBgColor && sceneBgColor.startsWith('#') ? sceneBgColor : '#27272a'}
            onChange={(hex) => onSceneBgChange?.(hex)}
            style={{ width: '100%', height: isColumn ? 110 : 72 }}
          />
        </div>

        <button
          type="button"
          className={`m-0 rounded-sm border border-yellow-600/35 px-2 py-1 text-[9px] uppercase tracking-wider text-yellow-500 hover:bg-yellow-500/10 shrink-0 ${
            isColumn ? 'w-full' : ''
          }`}
          onClick={() => onSceneBgChange?.(null)}
        >
          Reset default
        </button>
      </div>
    </ToolSubmenu>
  );
}
